import isClient from '@/Util/globals';
import { Language, languages } from '@/app/i18n/settingsClient';
import { i18n } from 'i18next';

export const loadTranslations = (i18n?: i18n): any => {
  let translations: any = {};

  if (!i18n?.isInitialized) {
    return undefined;
  }

  for (const lng of languages) {
    const translationsObject = i18n.getResourceBundle(lng, 'klaro');
    if (translationsObject) {
      translations[lng] = translationsObject;
    }
  }
  return translations;
};

export const getLanguageKlaro = () => {
  if (!isClient()) return Language.NL.toLocaleLowerCase();
  const formattedPathname = `${window.location.pathname}/`;
  const splittedPath = formattedPathname.split('/');
  const foundLanguage = Object.values(languages).find(lng => splittedPath.includes(lng));
  return foundLanguage ?? Language.NL;
};

export const addModalHeader = (i18n?: i18n) => {
  const translations = loadTranslations(i18n);
  const langUsed = getLanguageKlaro();
  const translation = translations?.[langUsed];
  const modal = document.querySelector('.cn-body');
  const header = document.createElement('div');
  header.innerHTML = translation?.header;
  header.className = 'cn-header';
  modal?.insertBefore(header, modal.firstChild);
};

export const moveAnalyticsButton = () => {
  const learnMoreButton = document.querySelector('.cm-btn-lern-more');
  const noticeParagraph = document.querySelector('.cn-body p');
  const cookieNoticeSpan = document.querySelector('.cookie-notice span');
  if (learnMoreButton && noticeParagraph && cookieNoticeSpan) {
    noticeParagraph.appendChild(learnMoreButton);
    learnMoreButton.className = 'contentNotice';
    const cleanText = cookieNoticeSpan.textContent?.trim() ?? '';
    learnMoreButton.textContent = cleanText;
    const paragraphWrapper = document.createElement('p');
    paragraphWrapper.textContent = cleanText;
    learnMoreButton.innerHTML = '';
    learnMoreButton.appendChild(paragraphWrapper);
    cookieNoticeSpan.remove();
  }
};

export const setKlaroElements = (i18n?: i18n) => {
  function addHideButtonListener(): void {
    const hideButton: HTMLButtonElement | null = document.querySelector('.klaro .hide');
    if (hideButton) {
      hideButton.addEventListener('click', () => {
        moveAnalyticsButton();
        addModalHeader(i18n);
      });
    }
  }

  const observer: MutationObserver = new MutationObserver(() => {
    addHideButtonListener();
  });
  const klaroElement: HTMLElement | null = document.querySelector('.klaro');
  if (klaroElement) {
    observer.observe(klaroElement, {
      childList: true,
      subtree: true
    });
  }
  addHideButtonListener();
};
